import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import { ModalController } from "@ionic/angular";
import { ProductDetailsComponent } from "src/app/product-details/product-details.component";
import { Subscription } from "rxjs";
import * as fromApp from "../../../../store/app.reducer";
import * as selectors from "../../../../store/app.selectors";
import { ProductDetailsOperationsService } from "src/app/product-details/product-details-operations.service";

@Component({
  selector: "app-product-item-mobile-image",
  templateUrl: "./product-item-mobile-image.component.html",
  styleUrls: ["./product-item-mobile-image.component.scss"],
})
export class ProductItemMobileImageComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() imageBrowser: any;
  @Input() product_id;
  @Input() category_id;
  @Input() hyperCategories: any;
  @Input() cartProductIds: any;
  @Input() groupStoreData: any;
  @Input() selectedDineInTable: any;
  @Input() selectedPreorderDate: any;
  @Input() orderPickup: any;
  @Input() dineIn: any;
  @Input() favoriteProduct: boolean;
  @Input() fromUnavailableProductsModal: boolean;
  @Input() categoryBadge: string;

  public product: any;
  public browserPlatform: any;
  public productInCart: boolean = false;
  public productInCartCounter: number = 0;
  public imageUrl;

  private deliveryMethodAddressSub: Subscription;
  private productSub: Subscription;
  private groupAppSub: Subscription;
  private productDetailsModal: any;

  constructor(
    private store: Store<fromApp.AppState>,
    private productDetailsOperationsService: ProductDetailsOperationsService,
    private modalCtrl: ModalController
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes.product_id &&
      changes.product_id.currentValue !== changes.product_id.previousValue &&
      changes.product_id.previousValue
    ) {
      if (this.productSub) {
        this.productSub.unsubscribe();
      }
      if (this.hyperCategories && this.hyperCategories.length > 0) {
        this.productSub = this.store
          .select(
            selectors.getProductItemByCategoryIdProductIdForHyperCategories(
              this.category_id,
              this.product_id
            )
          )
          .pipe(distinctUntilChanged())

          .subscribe((prd) => {
            if (prd && !_.isEqual(prd, this.product)) {
              this.product = _.cloneDeep(prd);
              this.imageUrl =
                "https://images.deliverymanager.gr/" +
                this.product.image.true["4x3"].path +
                (this.groupStoreData.webp
                  ? ".webp"
                  : this.product.image.true["4x3"].type || ".jpg");
              this.unsubscibeSelectorDebounced();
            }
          });
      } else {
        this.productSub = this.store
          .select(
            !this.favoriteProduct
              ? selectors.getProductItemByCategoryIdProductId(
                  this.category_id,
                  this.product_id
                )
              : selectors.getProductItemAllCategoriesByCategoryIdProductId(
                  this.category_id,
                  this.product_id
                )
          )
          .pipe(distinctUntilChanged())

          .subscribe((prd) => {
            if (prd && !_.isEqual(prd, this.product)) {
              this.product = _.cloneDeep(prd);
              this.imageUrl =
                "https://images.deliverymanager.gr/" +
                this.product.image.true["4x3"].path +
                (this.groupStoreData.webp
                  ? ".webp"
                  : this.product.image.true["4x3"].type || ".jpg");
              this.unsubscibeSelectorDebounced();
            }
          });
      }
    }
    if (
      changes &&
      changes.cartProductIds &&
      changes.cartProductIds.currentValue !==
        changes.cartProductIds.previousValue &&
      changes.cartProductIds.previousValue
    ) {
      this.checkIfProductIsAddedToCart();
    }
  }

  ngOnInit() {
    if (this.hyperCategories && this.hyperCategories.length > 0) {
      this.productSub = this.store
        .select(
          selectors.getProductItemByCategoryIdProductIdForHyperCategories(
            this.category_id,
            this.product_id
          )
        )
        .pipe(distinctUntilChanged())

        .subscribe((prd) => {
          if (prd && !_.isEqual(prd, this.product)) {
            this.product = _.cloneDeep(prd);
            this.imageUrl =
              "https://images.deliverymanager.gr/" +
              this.product.image.true["4x3"].path +
              (this.groupStoreData.webp
                ? ".webp"
                : this.product.image.true["4x3"].type || ".jpg");

            this.unsubscibeSelectorDebounced();
          }
        });
    } else {
      this.productSub = this.store
        .select(
          !this.favoriteProduct
            ? selectors.getProductItemByCategoryIdProductId(
                this.category_id,
                this.product_id
              )
            : selectors.getProductItemAllCategoriesByCategoryIdProductId(
                this.category_id,
                this.product_id
              )
        )
        .pipe(distinctUntilChanged())

        .subscribe((prd) => {
          if (prd && !_.isEqual(prd, this.product)) {
            this.product = _.cloneDeep(prd);
            this.imageUrl =
              "https://images.deliverymanager.gr/" +
              this.product.image.true["4x3"].path +
              (this.groupStoreData.webp
                ? ".webp"
                : this.product.image.true["4x3"].type || ".jpg");
            this.unsubscibeSelectorDebounced();
          }
        });
    }

    this.checkIfProductIsAddedToCart();
  }

  private unsubscibeSelectorDebounced = _.debounce(() => {
    this.unsubscribeSelector();
  }, 1000);

  unsubscribeSelector() {
    if (this.productSub) {
      this.productSub.unsubscribe();
    }
  }

  checkIfProductIsAddedToCart() {
    this.productInCartCounter = 0;
    if (this.cartProductIds && this.product) {
      this.productInCart = _.includes(
        this.cartProductIds,
        this.product.product_id
      );
      this.productInCartCounter = _.filter(this.cartProductIds, (id) => {
        if (id === this.product.product_id) {
          return id;
        }
      }).length;
    }
  }

  presentProductDetailsModal(product) {
    if (!this.productDetailsModal) {
      this.productDetailsModal = true;
      this.showProductDetailsModal(product);
    }
  }

  async showProductDetailsModal(product) {
    let product_id: string;
    let cart_id: string;
    if (product && product.product_id) {
      product_id = product.product_id;
    }

    if (product && product.cart_id) {
      cart_id = product.product_id;
    }
    let detailsCssClass = "productDetailsModal";
    if (this.fromUnavailableProductsModal) {
      detailsCssClass =
        this.productDetailsOperationsService.getProductDetailsModalCssClass(
          _.cloneDeep(product),
          _.cloneDeep({
            height: window.innerHeight,
            width: window.innerWidth,
          })
        );
    }

    this.productDetailsModal = await this.modalCtrl.create({
      component: ProductDetailsComponent,
      cssClass: detailsCssClass,
      animated: true,
      componentProps: {
        product_id: product_id,
        cart_id: cart_id,
      },
      backdropDismiss: false,
    });

    await this.productDetailsModal.present();
    this.productDetailsModal.onDidDismiss().then(() => {
      this.productDetailsModal = null;
    });
  }

  trackFn(index, item) {
    return index;
  }

  ngOnDestroy() {
    this.product = null;
    this.imageUrl = null;

    if (this.productDetailsModal) {
      this.productDetailsModal.dismiss();
      this.productDetailsModal = null;
    }
    if (this.productSub) {
      this.productSub.unsubscribe();
    }
  }
}
